import { Fragment } from 'react';

import SendTabs from './send-tabs/send-tabs';
import SendView from './views/send-view';
import ReceiveView from './views/receive-view';
import EnterReceiverView from './views/enter-receiver-view';
import ReviewView from './views/review-view';
import SuccessView from './views/success-view';

import { OptionType } from 'types';
import { VIEWS } from 'lib/constants';

const RenderStepContent = ({
  step,
  stepTab,
  closeModal,
  estimatedTotalFees,
  estimatedTotalInNear
}: {
  step: string;
  stepTab: [OptionType, (tab: OptionType) => void];
  closeModal: () => void;
  estimatedTotalFees?: string;
  estimatedTotalInNear?: string;
}) => {
  const [tab, setTab] = stepTab;
  switch (step) {
    case VIEWS.ENTER_AMOUNT:
      return (
        <Fragment>
          <SendTabs tab={tab} onSelect={(t) => setTab(t)} />
          {tab.value === 'send' && <SendView />}
          {tab.value === 'receive' && <ReceiveView />}
        </Fragment>
      );
    case VIEWS.ENTER_RECEIVER:
      return <EnterReceiverView />;
    case VIEWS.REVIEW:
      return (
        <ReviewView
          estimatedFeesInNear={estimatedTotalFees}
          estimatedTotalInNear={estimatedTotalInNear}
        />
      );
    case VIEWS.SUCCESS:
      return <SuccessView closeModal={closeModal} />;
  }
};

export default RenderStepContent;
